import { Text } from "@mantine/core";
import { ReactElement } from "react";
import {
  DEFAULT_RED_COLOR,
  DEFAULT_WHITE_COLOR,
} from "../../../_graphic_design";

interface Props {
  name: string;
  onSelect: () => void;
  photo: string;
  selected: boolean;
}

export default function Goalkeeper({
  name,
  onSelect,
  photo,
  selected,
}: Props): ReactElement {
  return (
    <div
      style={{
        borderColor: selected ? DEFAULT_RED_COLOR : "transparent",
        borderWidth: 2,
        borderStyle: "solid",
        boxSizing: "border-box",
        padding: 10,
        width: "50%",
      }}
    >
      <img
        alt={name}
        onClick={onSelect}
        src={photo}
        style={{ cursor: "pointer" }}
      />

      <Text
        className="text-xl text-center font-bold"
        sx={{
          color: DEFAULT_WHITE_COLOR,
        }}
        mt={20}
        dangerouslySetInnerHTML={{ __html: name }}
      />
    </div>
  );
}
